import { Link } from "react-router-dom";
import { Minus, Plus, ShoppingBag, X } from "lucide-react";
import { useI18n } from "@/i18n";
import { useCart } from "@/lib/cart";
import { formatPrice } from "@/lib/utils";

export default function CartDrawer() {
  const { t } = useI18n();
  const { items, subtotal, isOpen, closeCart, removeItem, updateQuantity } = useCart();
  if (!isOpen) return null;

  return (
    <>
      <button className="cart-backdrop" onClick={closeCart} aria-label="Close cart" />
      <aside className="cart-drawer" aria-label={t.cart.title}>
        <header className="cart-drawer-header">
          <div><ShoppingBag size={18} /><span>{t.cart.title}</span></div>
          <button onClick={closeCart} aria-label={t.common.close}><X size={20} /></button>
        </header>

        <div className="cart-drawer-items">
          {items.length === 0 ? (
            <div className="cart-empty"><ShoppingBag size={32} /><p>{t.cart.empty}</p></div>
          ) : items.map((item) => (
            <article className="cart-line" key={`${item.id}-${item.printSize || "original"}`}>
              <img src={item.image} alt={item.title} />
              <div className="cart-line-copy">
                <span>{item.category}</span>
                <h3>{item.title}</h3>
                {item.printSize && <p className="text-xs">{item.printSize}</p>}
                <strong>{formatPrice(item.price, item.currency)}</strong>
                <div className="cart-quantity">
                  <button onClick={() => updateQuantity(item.id, item.quantity - 1, item.printSize)}><Minus size={13} /></button>
                  <span>{item.quantity}</span>
                  <button disabled={item.category === "original"} onClick={() => updateQuantity(item.id, item.quantity + 1, item.printSize)}><Plus size={13} /></button>
                </div>
              </div>
              <button className="cart-remove" onClick={() => removeItem(item.id, item.printSize)} aria-label={t.cart.remove}><X size={16} /></button>
            </article>
          ))}
        </div>

        {items.length > 0 && (
          <footer className="cart-drawer-footer">
            <div><span>{t.cart.subtotal}</span><strong>{formatPrice(subtotal, items[0].currency)}</strong></div>
            <p>{t.checkout.secure}</p>
            <Link to="/checkout" onClick={closeCart}>{t.cart.checkout}</Link>
          </footer>
        )}
      </aside>
    </>
  );
}
